import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "~/lib/utils";

const badgeVariants = cva(
  "inline-flex w-fit items-center rounded-md border border-transparent transition-colors",
  {
    variants: {
      variant: {
        default: "bg-bouncie-900 text-white",
        destructive: "bg-feedback-error-bold text-white",
        outline: "border-bouncie-900 bg-transparent text-white",
        inverse: "bg-bouncie-200 text-figma-blue-midnight",
        success: "bg-feedback-success-bold text-neutral-900",
        glass: "border-0 bg-gradient-to-br from-white/20 to-white/10 text-white shadow-[inset_0_0_0_0.5px_rgba(255,255,255,0.3),inset_1px_1px_0_rgba(255,255,255,0.55),2px_4px_12px_rgba(0,0,0,0.25)] backdrop-blur-xl backdrop-saturate-200",
        "semi-transparent": "bg-figma-grey-mist/30 text-figma-grey-pearl",
      },
      size: {
        default: "gap-1 px-2 py-1 text-xs leading-[18px] font-bold",
        lg: "gap-1 px-3 py-1 text-sm leading-5 font-normal",
      },
    },
    defaultVariants: { variant: "default", size: "default" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {
  icon?: React.ReactNode;
}

function Badge({ className, variant, size, icon, children, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant, size }), className)} {...props}>
      {icon}
      {children}
    </div>
  );
}

export { Badge, badgeVariants };
